// !FIXME - Easy - Flow type this file
// FlyerDetail Presentational Component

import React from 'react'
import { Divider, Container, Loader } from 'semantic-ui-react'
import { css } from 'emotion'
import { prussian } from 'constants/inlineStyles'

import FlyerDetailMenu from './components/FlyerDetailMenu'
import FlyerDetailBody from './components/FlyerDetailBody'
import FlyerFooter from '../../components/FlyerFooter'
import ModalManager from './components/ModalManager/ModalManager'

let styles = {}

const FlyerDetail = ({
  resource,
  resourceId,
  resourceName,
  coBrandingUrl,
  coBrandingAlt,
  coBrandingLogoLink,
  flyer,
  schools
}) => {
  const getCoBrading = () => {
    const coBradingImg = (
      <img
        alt={coBrandingAlt || 'District or School Logo'}
        src={coBrandingUrl}
      />
    )

    return (
      <div>
        {coBrandingLogoLink ? (
          <a href={coBrandingLogoLink} target="_blank">
            {coBradingImg}
          </a>
        ) : (
          coBradingImg
        )}
      </div>
    )
  }
  return (
    <div style={styles.flyerDetailWrapper}>
      {flyer ? (
        <React.Fragment>
          <Container>
            <div className={cn.container}>
              <div className={cn.titleContainer}>
                {coBrandingUrl && getCoBrading()}
                <div>
                  <h1 data-testid="resource-name">{resourceName}</h1>
                </div>
              </div>
            </div>
            <FlyerDetailMenu
              resource={resource}
              resourceId={resourceId}
              flyer={flyer}
            />
            <FlyerDetailBody flyer={flyer} schools={schools} />
            <ModalManager />
          </Container>
          <Divider style={styles.divider} />
          <Container>
            <FlyerFooter />
          </Container>
        </React.Fragment>
      ) : (
        <Loader active inline="centered" />
      )}
    </div>
  )
}

styles = {
  flyerDetailWrapper: {
    display: 'flex',
    flexFlow: 'column nowrap',
    minHeight: '100vh'
  },
  divider: { margin: '0', marginTop: '1rem' }
}

const cn = {
  container: css`
    min-height: 1px;
    margin-top: 32px;
    margin-bottom: 12px;
    @media (max-width: 480px) {
      margin-top: 24px;
    }
  `,
  titleContainer: css`
    display: flex;
    align-items: center;
    min-height: 60px;
    justify-content: center;
    & img {
      height: 60px;
    }
    & h1 {
      font-family: 'Proxima Nova';
      font-size: 28px;
      line-height: 32px;
      margin-left: 10px;
      font-weight: 600;
      color: ${prussian};
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 416px;
    }
    @media (max-width: 480px) {
      min-height: 48px;
      & img {
        height: 48px;
      }
      & h1 {
        font-size: 22px;
        line-height: 32px;
        white-space: normal;
        max-width: 360px;
      }
    }
  `
}

export default FlyerDetail



// WEBPACK FOOTER //
// ./src/screens/Flyers/screens/FlyerDetail/FlyerDetail.js